import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Checkbox from "../../Components/checkbox/Checkbox";
import ApiDropdown from "../../Components/DropDown/Apidropdown";
import Input from "../../Components/input/input";
import config from "../../config";
import { toRelatedItems } from "../../Components/Lookup/IncidentLookUp";
import "../../Style/IncidentAdd.css";
import { useFetchFullName } from "../Incidents/Hooks/useFetchFullName";
import { Change, initialChange } from "./Change";
import TaskGridLookup from "../../Components/Lookup/Lookup";
import { ChangeData } from "../../utils/Change/changeTypes";
import { KnowledgeBaseData } from "../../utils/KnowledgeBase/KnowledgeBaseTypes";
import { RmaData } from "../../utils/Rma/rmaTypes";
import { TaskData } from "../../utils/Task/taskTypes";
import FileUploader from "../../Components/FileUpload/FileUpload";
import { IncidentData } from "../../utils/Incident/incidentTypes";
import { ProblemData } from "../../utils/Problem/problemTypes";
import TextArea from "../../Components/TextArea/TextArea";
import { authFetch } from "../../utils/Security/authFetch";
import { handleEdit } from "../../utils/Change/changeHandlers";
import { joinMulti, splitMulti } from "../../utils/multiValue";
type Person = {
  id: number;
  name: string;
};
type Message = {
  id: number;
  username: string;
  message: string;
  date: string;
};
function ChangeEdit() {
  const [change, setChange] = useState<Change>(initialChange);
  const { id } = useParams();
  const navigate = useNavigate();
  const [journalMessages, setJournalMessages] = useState<Message[]>([]);

  const [emails, setEmails] = useState<[]>();
  const [customer, setCustomer] = useState<
    string | number | (string | number)[] | undefined
  >(undefined);
  const [isTaskLookupOpen, setIsTaskLookupOpen] = useState(false);
  const [selectedTask, setSelectedTask] = useState<
    (
      | TaskData
      | ChangeData
      | RmaData
      | KnowledgeBaseData
      | ProblemData
      | IncidentData
    )[]
  >([]);
  const organization = localStorage.getItem("organization") || undefined;

  const [network, setNetwork] = useState<
    string | number | (string | number)[] | null
  >(null);
  const [site, setSite] = useState<
    string | number | (string | number)[] | null
  >(null);
  const isAdmin = localStorage.getItem("isAdmin") === "true";
  const handleTaskSelect = (
    tasks: (
      | TaskData
      | ChangeData
      | RmaData
      | KnowledgeBaseData
      | ProblemData
      | IncidentData
    )[]
  ) => {
    const ticketIds = tasks.map((t) => t.ticketId); // collect all selected ticketIds
    handleDataChange("relatedobject", ticketIds); // now this should be an array
    setSelectedTask(tasks); // you might rename this to selectedTasks now
  };
  // Lookup pre-ticks rows by tab, so tag each saved ticketId with its source
  const relatedLookupItems = useMemo(
      () =>
          toRelatedItems(change.relatedobject).map((item) => {
            const id = String(item.ticketId);
            const source =
                id.startsWith("INC") || id.startsWith("IND")
                    ? "incident"
                    : id.startsWith("CHN")
                        ? "change"
                        : id.startsWith("TSK")
                            ? "task"
                            : id.startsWith("PRB")
                                ? "problem"
                                : id.startsWith("RMA")
                                    ? "rma"
                                    : "knowledge";
            return { ...item, source } as unknown as typeof item;
          }),
      [change.relatedobject],
  );
  const handleOpenTaskLookup = () => setIsTaskLookupOpen(true);
  const handleCloseTaskLookup = () => setIsTaskLookupOpen(false);
  useEffect(() => {
    if (id) {
      authFetch(`${config.apiBaseUrl}/api/changes/${id}`)
        .then((res) => res.json())
        .then((data) => setChange(data))
        .catch((err) => console.error("Failed to fetch change:", err));
      //console.log("dataa", change);
    }
  }, [id]);

  useEffect(() => {
    setCustomer(change.affectedCustomer);
  }, [change.affectedCustomer]);

  useFetchFullName((fullName: string) => {
    setChange((prev) => ({ ...prev, user: fullName }));
  });

  const handleDataChange = (field: keyof Change, value: any) => {
    setChange((prev) => ({ ...prev, [field]: value }));
  };
  const handleCancel = () => {
    navigate("/change");
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const updatedChange: Change = {
      ...change,
      affectedSite:
        localStorage.getItem("isAllSite") === "true"
          ? ["All Sites"]
          : change.affectedSite,
      affectedLink:
        localStorage.getItem("isAllLink") === "true"
          ? ["All Links"]
          : change.affectedLink,
      affectedNetwork:
        localStorage.getItem("isAllNetwork") === "true"
          ? ["All Networks"]
          : change.affectedNetwork,
    };
    authFetch(`${config.apiBaseUrl}/api/changes/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(updatedChange),
    })
      .then((res) => res.json())
      .then(async (data) => {
        const fetchMessages = async () => {
          if (!data?.ticketId) return;
          const res = await authFetch(
            `${config.apiBaseUrl}/api/messages/ticket/${data.ticketId}`
          );
          if (res.ok) setJournalMessages(await res.json());
        };
        await handleEdit(data, navigate, fetchMessages);
        navigate("/change");
      })
      .catch((err) => console.error("Failed to update change:", err));
  };

  return (
    <div className="change-form">
      <form onSubmit={handleSubmit}>
        <section className="form-section">
          <h3>Change Information</h3>
          <div className="grid">
            <Input
              type="text"
              label="Created By"
              value={change.createdby ?? ""}
              onChange={(val) => handleDataChange("createdby", val)}
              readOnly
            />
            {isAdmin && (
              <ApiDropdown
                api="users"
                labelKey="username"
                valueKey="id"
                label="User"
                onChange={async (val) => {
                  handleDataChange("userid", val);
                  //console.log("val>>>>",val)
                  if (val != null) {
                    try {
                      const res = await authFetch(
                        `${config.apiBaseUrl}/api/users/${val}`
                      );
                      if (!res.ok) throw new Error("User not found");
                      const user = await res.json();
                      handleDataChange("email", user.email);
                    } catch (err) {
                      console.error("Error fetching user:", err);
                    }
                  }
                }}
              />
            )}
            <Input
              type="text"
              label="Ticket Id"
              readOnly
              value={change.ticketId || ""}
              onChange={(val) => handleDataChange("ticketId", val)}
            />

            <ApiDropdown
              api="ChangePhases"
              required
              labelKey="name"
              valueKey="name"
              disabled
              value={change.phase}
              label="Phase"
              onChange={(val) => handleDataChange("phase", val)}
            />
            <Input
              type="datetime-local"
              readOnly
              label="Ticket creation Date/time"
              value={change.ticketCreationDatetime}
              onChange={(val) =>
                handleDataChange("ticketCreationDatetime", val)
              }
            />
            <Input
              type="datetime-local"
              label="Ticket closure  Date/Time"
              readOnly
              value={change.ticketClosureDatetime || ""}
              onChange={(val) => handleDataChange("ticketClosureDatetime", val)}
            />
            <Input
              type="datetime-local"
              label="Planned Start Date/Time (UTC)"
              value={change.changeStartDatetime || ""}
              onChange={(val) => handleDataChange("changeStartDatetime", val)}
            />
            <Input
              type="datetime-local"
              label="Planned End Date/Time (UTC)"
              value={change.changeCloseDatetime || ""}
              onChange={(val) => handleDataChange("changeCloseDatetime", val)}
            />
            <Input
              type="datetime-local"
              label="Impact Planned Start Date/Time (UTC)"
              value={change.imapctchangeStartDatetime || ""}
              onChange={(val) =>
                handleDataChange("imapctchangeStartDatetime", val)
              }
            />
            <Input
              type="datetime-local"
              label="Impact Planned End Date/Time (UTC)"
              value={change.impactchangeCloseDatetime || ""}
              onChange={(val) =>
                handleDataChange("impactchangeCloseDatetime", val)
              }
            />
            {isAdmin && (
              <>
                <Checkbox
                  label="Customer Approval"
                  checked={change.customerapproval || false}
                  onChange={(e) =>
                    handleDataChange("customerapproval", e.target.checked)
                  }
                />
                <Checkbox
                  label="CAB Approval"
                  onChange={(e) =>
                    handleDataChange("cabapproval", e.target.checked)
                  }
                  checked={change.cabapproval}
                />
              </>
            )}
          </div>
        </section>
        <section className="form-section">
          <h3>Customer & Network</h3>
          <div className="grid">
            {!isAdmin && (
              <ApiDropdown
                api="affected-customers"
                labelKey="customername"
                value={organization}
                valueKey="customername"
                label="Customer"
                disabled
                isMulti
                onOpen={async () => {
                  try {
                    const responseIds = await authFetch(
                      `${config.apiBaseUrl}/api/users/id-by-organization?organization=${organization}`
                    );
                    if (!responseIds.ok)
                      throw new Error(
                        `HTTP error! status: ${responseIds.status}`
                      );
                    const userIds = await responseIds.json();
                    const userIdsParam = Array.isArray(userIds)
                      ? userIds.join(",")
                      : userIds;
                    const responseEmails = await authFetch(
                      `${config.apiBaseUrl}/api/users/email-by-id?id=${userIdsParam}`
                    );
                    if (!responseEmails.ok)
                      throw new Error(
                        `HTTP error! status: ${responseEmails.status}`
                      );
                    const emails = await responseEmails.json();
                    setEmails(emails);
                    handleDataChange("foruserid", userIds);
                    handleDataChange("affectedCustomer", [organization]);
                  } catch (error) {
                    console.error("Failed to fetch customer or emails:", error);
                  }
                }}
              />
            )}
            {isAdmin && (
              <ApiDropdown
                api="affected-customers"
                labelKey="customername"
                valueKey="customername"
                label="Customer"
                value={customer}
                isMulti
                onChange={async (val) => {
                  setCustomer(val);
                  try {
                    const responseIds = await authFetch(
                      `${config.apiBaseUrl}/api/users/id-by-organization?organization=${val}`
                    );
                    if (!responseIds.ok)
                      throw new Error(
                        `HTTP error! status: ${responseIds.status}`
                      );
                    const userIds = await responseIds.json();
                    const userIdsParam = Array.isArray(userIds)
                      ? userIds.join(",")
                      : userIds;
                    const responseEmails = await authFetch(
                      `${config.apiBaseUrl}/api/users/email-by-id?id=${userIdsParam}`
                    );
                    if (!responseEmails.ok)
                      throw new Error(
                        `HTTP error! status: ${responseEmails.status}`
                      );
                    const emails = await responseEmails.json();
                    setEmails(emails);
                    handleDataChange("foruserid", userIds);
                    handleDataChange("affectedCustomer", val);
                  } catch (error) {
                    console.error("Failed to fetch customer or emails:", error);
                  }
                }}
              />
            )}
            {!isAdmin && organization && (
              <ApiDropdown
                api={`everything/networks?customer=${organization}`}
                labelKey="label"
                valueKey="value"
                label="Networks"
                value={
                  change.affectedNetwork?.includes("All")
                    ? "all"
                    : change.affectedNetwork || ""
                }
                isMulti
                onChange={(val) => {
                  setNetwork(val);
                  handleDataChange("affectedNetwork", val);
                }}
              />
            )}

            {!isAdmin && organization && (
              <>
                {(network || change.affectedNetwork) && (
                  <ApiDropdown
                    api={`everything/sites?customer=${organization}&network=${
                      network || change.affectedNetwork
                    }`}
                    labelKey="label"
                    valueKey="value"
                    label="Site"
                    value={change.affectedSite}
                    isMulti
                    onChange={(val) => {
                      setSite(val);
                      handleDataChange("affectedSite", val);
                    }}
                  />
                )}

                {(site || change.affectedSite) && (
                  <ApiDropdown
                    api={`everything/links?customer=${organization}&network=${
                      network || change.affectedNetwork
                    }&site=${site || change.affectedSite}`}
                    labelKey="label"
                    valueKey="value"
                    label="Link"
                    value={change.affectedLink}
                    isMulti
                    onChange={(val) => handleDataChange("affectedLink", val)}
                  />
                )}

                <ApiDropdown
                  api={`everything/asset?customer=${organization}&network=${network}`}
                  labelKey="label"
                  valueKey="value"
                  label="Assets"
                  isMulti
                  onChange={(val) => handleDataChange("asset", val)}
                />
              </>
            )}

            {isAdmin && (
              <>
                {(customer || change.affectedCustomer) && (
                  <ApiDropdown
                    api={`everything/networks?customer=${
                      customer || change.affectedCustomer
                    }`}
                    labelKey="label"
                    valueKey="value"
                    label="Networks"
                    value={change.affectedNetwork || "all"}
                    isMulti
                    onChange={(val) => {
                      setNetwork(val);
                      handleDataChange("affectedNetwork", val);
                    }}
                  />
                )}

                {(network || change.affectedNetwork) && (
                  <ApiDropdown
                    api={`everything/sites?customer=${
                      customer || change.affectedCustomer
                    }&network=${network || change.affectedNetwork}`}
                    labelKey="label"
                    valueKey="value"
                    value={change.affectedSite}
                    label="Site"
                    isMulti
                    onChange={(val) => {
                      setSite(val);
                      handleDataChange("affectedSite", val);
                    }}
                  />
                )}

                {(site || change.affectedSite) && (
                  <ApiDropdown
                    api={`everything/links?customer=${
                      customer || change.affectedCustomer
                    }&network=${network || change.affectedNetwork}&site=${
                      site || change.affectedSite
                    }`}
                    labelKey="label"
                    valueKey="value"
                    label="Link"
                    value={change.affectedLink}
                    isMulti
                    onChange={(val) => handleDataChange("affectedLink", val)}
                  />
                )}

                <ApiDropdown
                  api={`everything/asset?customer=${customer}&network=${network}`}
                  labelKey="label"
                  valueKey="value"
                  label="Assets"
                  isMulti
                  onChange={(val) => handleDataChange("asset", val)}
                />

                <ApiDropdown
                  api={`everything/antenna?customer=${customer}`}
                  labelKey="label"
                  valueKey="value"
                  label="Antennas"
                  isMulti
                  value={splitMulti(change.affectedAntenna)}
                  onChange={(val) =>
                    handleDataChange("affectedAntenna", joinMulti(val))
                  }
                />
              </>
            )}
          </div>
        </section>
        <section className="form-section">
          <h3>Change severity</h3>
          <div className="grid">
            <ApiDropdown
              api="Urgencys"
              required
              labelKey="name"
              valueKey="name"
              value={change.priority}
              label="Priority"
              onChange={(val) => handleDataChange("priority", val)}
            />
          </div>
        </section>{" "}
        <section className="form-section">
          <h3>Change details</h3>
          <div className="grid2">
            <TextArea
              label="Summary"
              value={change.summary}
              style={{
                minHeight: "30px",
                minWidth: "90%",
                backgroundColor: "white",
              }}
              onChange={(val) => handleDataChange("summary", val)}
            />
            <TextArea
              label="Description"
              style={{
                minHeight: "100px",
                minWidth: "90%",
                backgroundColor: "white",
              }}
              required={true}
              value={change.description}
              onChange={(val) => handleDataChange("description", val)}
            />
            <TextArea
              
              label="Solution"
              style={{
                minHeight: "100px",
                minWidth: "90%",
                backgroundColor: "white",
              }}
              value={change.solution || ""}
              onChange={(val) => handleDataChange("solution", val)}
            />
            {isAdmin && (
              <>
                <TextArea
                  label="Risk"
                  value={change.risk}
                  style={{
                    minHeight: "30px",
                    minWidth: "90%",
                    backgroundColor: "white",
                  }}
                  onChange={(val) => handleDataChange("risk", val)}
                />
                <TextArea
                  label="RollBack Strategy "
                  value={change.rollbackstrategy}
                  style={{
                    minHeight: "30px",
                    minWidth: "90%",
                    backgroundColor: "white",
                  }}
                  onChange={(val) => handleDataChange("rollbackstrategy", val)}
                />
                <ApiDropdown<Person>
                  api="requiredResources"
                  labelKey="name"
                  valueKey="name"
                  label="Required Resources"
                  value={change.requiredresources}
                  isMulti
                  onChange={(val) => handleDataChange("requiredresources", val)}
                />
              </>
            )}
            <ApiDropdown
              api="ClosureCodesTask"
              labelKey="name"
              valueKey="name"
              label="Closure Code"
              value={change.closureCode}
              onChange={(val) => handleDataChange("closureCode", val)}
            />
          </div>
        </section>
        {isAdmin && (
          <section className="form-section">
            <h3>type of changes</h3>
            <div className="grid">
              <ApiDropdown
                api="ChangeTemplates"
                required
                value={change.changetemplate || ""}
                labelKey="name"
                valueKey="name"
                label="Change Templates"
                onChange={(val) => handleDataChange("changetemplate", val)}
              />
              <ApiDropdown
                api="TypeOfChanges"
                required
                labelKey="name"
                valueKey="name"
                value={change.typeofchange || ""}
                label="Type of Change"
                onChange={(val) => handleDataChange("typeofchange", val)}
              />
            </div>
          </section>
        )}
        {isAdmin && (
          <section className="form-section">
            <h3>Responsibility</h3>
            <div className="grid">
              {/* <ApiDropdown
                api="Team"
                labelKey="name"
                valueKey="id"
                label="Responsible Team"
                value={change.teamId}
                onChange={(val) => handleDataChange("teamId", val)}
              />
              <ApiDropdown
                api="Person"
                labelKey="name"
                valueKey="id"
                label="Responsible Person"
                value={change.personId}
                onChange={(val) => handleDataChange("personId", val)}
              /> */}
              <Input
                readOnly
                type="text"
                label="Responsible Team"
                value={change.responsibleTeam || ""}
                onChange={() => {}}
              />
              <Input
                readOnly
                type="text"
                label="Responsible Person"
                value={change.responsiblePerson || ""}
                onChange={() => {}}
              />
            </div>
          </section>
        )}
        <section className="form-section">
          <h3>Related Object</h3>
          <div className="grid">
            <FileUploader
              value={change.filePath}
              onRemove={(path) =>
                handleDataChange("filePath", (change.filePath || []).filter((p: any) => p !== path))
              }
              onChange={async (files, paths) => {
                if (!files || !paths.length) return;
                const uploadedPaths: string[] = [];
                for (let i = 0; i < files.length; i++) {
                  const formData = new FormData();
                  formData.append("file", files[i]);
                  try {
                    const response = await authFetch(
                      `${config.apiBaseUrl}/api/changes/upload`,
                      {
                        method: "POST",
                        body: formData,
                      }
                    );
                    if (response.ok) {
                      const { path } = await response.json();
                      uploadedPaths.push(path);
                    } else {
                      console.error(`Upload failed for file: ${files[i].name}`);
                    }
                  } catch (error) {
                    console.error("Error uploading file", error);
                  }
                }
                if (uploadedPaths.length) {
                  handleDataChange("filePath", [
                    ...(change.filePath || []),
                    ...uploadedPaths,
                  ]);
                }
              }}
            />
            {isAdmin && (
                <>
                  <button type="button" onClick={handleOpenTaskLookup}>
                    Select Related Ticket
                  </button>
                  {toRelatedItems(change.relatedobject).length > 0 && (
                      <div>
                        <p>
                          <strong>Selected Tasks:</strong>
                        </p>
                        <ul>
                          {toRelatedItems(change.relatedobject).map((task, index) => (
                              <li key={index}>{task.ticketId}</li>
                          ))}
                        </ul>
                      </div>
                  )}

                <TaskGridLookup
                  isOpen={isTaskLookupOpen}
                  onClose={handleCloseTaskLookup}
                  selectedItems={toRelatedItems(change.relatedobject)}
                  onSelect={handleTaskSelect}
                />
              </>
            )}
          </div>
        </section>
        <button onClick={handleSubmit}>Submit Change</button>
        <button type="button" onClick={handleCancel}>
          Cancel
        </button>
      </form>
    </div>
  );
}

export default ChangeEdit;
